import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import excelenteAvatar from "../../assets/bg/excelente-avatar-pre.png";
import { getFinExcelenteShellBackground } from "../../utils/quizFeedbackHtml";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";

function Scenario3Fin({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const videoRef = useRef(null);

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
        <div className="h-100">
        <div className="container-fluid position-relative h-100 p-0 bgCircleViolet">
            <div className="row h-100 m-0">
            <div className="col-md-12 position-relative h-100 p-0 overflow-hidden">
                <div className="content-overlay d-flex flex-column justify-content-start align-items-center h-75 px-5 position-relative pt-5">
                <h1 className="fin-big-phase-title mb-3 mt-2 px-2">
                  Han avanzado a la{" "}
                  <span className="fin-big-phase-title-accent">siguiente sala</span>
                </h1>
                <div className="quiz-result-avatar-row quiz-result-avatar-row--tight mb-4 mt-2 fin-excelente-row">
                  <span className="quiz-result-badge quiz-result-badge--correct quiz-result-badge--t-violet">
                    Excelente
                  </span>
                  <div
                    className="quiz-result-avatar-shell fin-excelente-shell"
                    style={{ background: getFinExcelenteShellBackground("violet") }}
                  >
                    <div className="quiz-result-avatar-inner">
                      <img src={excelenteAvatar} alt="" className="quiz-result-avatar-img" />
                    </div>
                  </div>
                </div>
                <div className="mt-3 d-flex align-items-center w-100 justify-content-end">
                    <NextButton
                    navigateTo={ROUTES.TRANSITION_SCENARIOS}
                    activeScenario={4}
                    color="violet"
                    />
                </div>
                </div>
            </div>
            </div>
        </div>

        <ScenarioBar activeScenario={activeScenario} />
        </div>
    );
}

export default injectIntl(Scenario3Fin);
